import type { CoachingGoal } from '@efdigital/ll-addon-data';
import type { CoachingCoachCoacheesCoacheeGoalsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/goals';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export type CoachingCoachCoacheesCoacheeGoalsGoalModel =
  CoachingCoachCoacheesCoacheeGoalsModel & {
    goal: CoachingGoal | undefined;
  };

export default class CoachingCoachCoacheesCoacheeGoalsGoalRoute extends Route<CoachingCoachCoacheesCoacheeGoalsGoalModel> {
  @service declare router: RouterService;

  model(params: {
    goal_id: string;
  }): CoachingCoachCoacheesCoacheeGoalsGoalModel {
    const parent = this.modelFor(
      'coaching.coach.coachees.coachee.goals'
    ) as CoachingCoachCoacheesCoacheeGoalsModel;
    const goal = parent.goals.find(
      (entry) => String(entry.id) === String(params.goal_id)
    );

    if (!goal) {
      void this.router.replaceWith(
        'coaching.coach.coachees.coachee.goals',
        parent.coachee.coacheeUserId
      );
    }

    return { ...parent, goal };
  }
}
